import { buildBreadcrumb } from '../lib/breadcrumbFormat';
import { TIKTOK_POST_COLUMN_SPEC, buildPostCards } from '../lib/postCards';
import { buildColumns, parentName } from '../lib/tableHelpers';
import InlinePostGrid, {
    type PostGridModel,
} from '../primitives/InlinePostGrid';
import type { VisualProps, VisualWidget } from '../types';

const TYPE_LABEL = 'Post';

function buildRelatedPostsModel({ input, output }: VisualProps): PostGridModel {
    // The pair's second identity — the backend stamps it on every related-posts
    // result; its absence means the payload shape drifted, so fail loud.
    const relatedName = output?.result?.related_entity_name;
    if (!relatedName) {
        throw new Error(
            'related posts visual: output is missing result.related_entity_name',
        );
    }
    const orderBy = output?.result?.order_by ?? input?.order_by;
    const columns = buildColumns(orderBy, TIKTOK_POST_COLUMN_SPEC).filter(
        (col) => col.isSort || !col.isGrowth,
    );
    // Title carries both entities: "Cerave + Eczema Posts" (CSS capitalizes).
    const anchorName = parentName(output);
    return {
        breadcrumb: buildBreadcrumb(output, TYPE_LABEL),
        title: {
            parent: [anchorName, relatedName].filter(Boolean).join(' + '),
            noun: 'posts',
        },
        link: output?.result?.dashboard_url,
        columns,
        cards: buildPostCards(output, columns),
    };
}

const RelatedPostsInlineList = ({ Frame, ...props }: VisualProps) => (
    <InlinePostGrid {...buildRelatedPostsModel(props)} Frame={Frame} />
);

const widget: VisualWidget = {
    match: (input) =>
        input?.data_source === 'tiktok' &&
        input?.entity_relationship === 'related_posts',
    Component: RelatedPostsInlineList,
};

export default widget;
